import { render, staticRenderFns } from "./zen.vue?vue&type=template&id=b1e21e60&"
import script from "./zen.vue?vue&type=script&lang=js&"
export * from "./zen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports